export const UTC_DATE_FORMAT = "dd LLL yyyy HH:mm:ss UTC";
export const SPECIAL_CHAR_REGEX = "^[a-zA-Z0-9-_]+( [a-zA-Z0-9-_]+)*$";
export const SPECIAL_CHAR_REGEX_MSG = "Invalid character entered.";

export const EQP_CATEGORY = {
  0: "Apollo",
  1: "Advantage",
  2: "PHController",
  3: "Custom",
};

export const EQP_TYPES = {
  0: "VSD",
  1: "Generator",
  2: "Software",
  3: "Custom",
};

export const CHANNEL_TYPES = [
  { key: "MODBUS", value: "MODBUS TCP/IP" },
  { key: "MODBUS", value: "MODBUS RTU over TCP" },
  { key: "MODBUS", value: "MODBUS Serial" },
  { key: "ANALOG_IO", value: "ANALOG" },
  { key: "DIGITAL_IO", value: "DIGITAL" },
  { key: "CALCULATED", value: "CALCULATED" },
];

export const TAG_SOURCE_TYPE = Object.freeze({
  ANALOG_INPUT: "ANALOG INPUT",
  ANALOG_OUTPUT: "ANALOG OUTPUT",
  DIGITAL_INPUT: "DIGITAL INPUT",
  DIGITAL_OUTPUT: "DIGITAL OUTPUT",
  MODBUS: "MODBUS",
  CALCULATED: "CALCULATED"
});

// export const TAG_SOURCE_TYPE = Object.freeze(['MODBUS', 'DIGITAL_IO', 'ANALOG_IO']);
export const MFactorEnableDataTypes = {
  Array: false,
  Ascii: false,
  Ascii8: false,
  Boolean: false,
  DateTime: false,
  Double: true,
  Integer: true,
  Long: true,
  Sint: true,
  String: false,
};
export const DATA_TYPES = Object.freeze({
  Array: "Array",
  Ascii: "Ascii",
  Ascii8: "Ascii8",
  Boolean: "Boolean",
  DateTime: "DateTime",
  Double: "Double",
  Integer: "Integer",
  Long: "Long",
  Sint: "Sint",
  String: "String",
});

export const DATA_TYPES_CALCULATED = Object.freeze({
  Double: "Double",
  Integer: "Integer",
  Long: "Long",
  Sint: "Sint",
  String: "String",
});

export const MODBUS_SCAN_CLASS = {
  1: "1 second",
  3: "3 seconds",
  5: "5 seconds",
  30: "30 seconds",
  60: "1 minute",
  300: "5 minutes",
  1800: "30 minutes",
  3600: "1 hour",
  86400: "24 hour",
};
export const SCAN_CLASS={
  1: "1 second",
  3: "3 seconds",
  5: "5 seconds",
  10: "10 seconds",
  30: "30 seconds",
  60: "1 minute",
  300: "5 minutes",
  1800: "30 minutes",
  3600: "1 hour",
  86400: "24 hour",
};


export const CHANNEL_TAG_TYPE_MAP = Object.freeze({
  MODBUS: "modbusSensorTags",
  ANALOG_INPUT: "analogInputTags",
  ANALOG_OUTPUT: "analogOutputTags",
  DIGITAL_INPUT: "digitalInputTags",
  DIGITAL_OUTPUT: "digitalOutputTags",
  CALCULATED: "calculatedTags"
});

export const MODBUS_TCP_Default = {
  port: 502,
  slaveId: 1,
};

export const DIGITAL_PORT = [
  { key: "1", value: "1" },
  { key: "2", value: "2" },
  { key: "3", value: "3" },
  { key: "4", value: "4" },
  { key: "5", value: "5" },
  { key: "6", value: "6" },
  { key: "7", value: "7" },
  { key: "8", value: "8" },
  { key: "9", value: "9" },
  { key: "10", value: "10" },
  { key: "11", value: "11" },
  { key: "12", value: "12" },
  { key: "13", value: "13" },
  { key: "14", value: "14" },
  { key: "15", value: "15" },
  { key: "16", value: "16" },
  { key: "17", value: "17" },
  { key: "18", value: "18" },
  { key: "19", value: "19" },
  { key: "20", value: "20" },
  { key: "21", value: "21" },
  { key: "22", value: "22" },
  { key: "23", value: "23" },
  { key: "24", value: "24" },
  { key: "25", value: "25" },
  { key: "26", value: "26" },
  { key: "27", value: "27" },
  { key: "28", value: "28" },
  { key: "29", value: "29" },
  { key: "30", value: "30" },
];

export const ANALOG_INPUT_PORT = [
  { key: "1", value: "IO" },
  { key: "2", value: "IA" },
  { key: "3", value: "IB" },
];
export const ANALOG_OUTPUT_PORT = [
  { key: "0", value: "0" },
  { key: "1", value: "1" },
  { key: "2", value: "2" },
  { key: "3", value: "3" },
];
export const CHANNELTYPE = {
  DIGITAL_INPUT: "DIGITAL_INPUT",
  DIGITAL_OUTPUT: "DIGITAL_OUTPUT",
  ANALOG_INPUT: "ANALOG_INPUT",
  ANALOG_OUTPUT: "ANALOG_OUTPUT",
  MODBUS: "MODBUS",
  CALCULATED:"CALCULATED"
};
export const CONSTANT_MODBUSTYPE = {
  MODBUSTCP: "MODBUS_TCP",
  MODBUSRTU: "MODBUS_RTU_TCP",
  RTU_SERIAL: "MODBUS_RTU_SERIAL",
  ASCII_SERIAL: "MODBUS_ASCII_SERIAL",
};

export const MODBUS_TYPES = [
  { key: "TCP", name: "MODBUS_TCP" },
  { key: "RTU", name: "MODBUS_RTU_TCP" },
  { key: "RTU_Serial", name: "MODBUS_RTU_SERIAL" },
  { key: "ASCII_Serial", name: "MODBUS_ASCII_SERIAL" },
];

export const EQUIPMENT_CATEGORIES = [
  { key: "Custom", name: "Custom" },
  { key: "Downhole_Gauge", name: "Downhole Gauge" },
  { key: "Gas_Detector", name: "Gas Detector" },
  { key: "Generator", name: "Generator" },
  { key: "Power_Supply", name: "Power Supply" },
  { key: "Receiver", name: "Receiver" },
  { key: "Software", name: "Software" },
  { key: "SWB", name: "SWB" },
  { key: "UPS", name: "UPS" },
  { key: "VSD", name: "VSD" },
  { key: "Wireless_Sensor", name: "Wireless Sensor" },
];

export const EQUIPMENT_TYPES = [
  { key: "Advantage", name: "Advantage" },
  { key: "Apollo", name: "Apollo" },
  { key: "Backup_Battery", name: "Backup Battery" },
  { key: "Base_Radio", name: "Base Radio" },
  { key: "Borets", name: "Borets" },
  { key: "Casing_Pressure", name: "Casing Pressure" },
  { key: "Combustible_Gas", name: "Combustible Gas" },
  { key: "Custom", name: "Custom" },
  { key: "Diesel_Generator", name: "Diesel Generator" },
  { key: "Flowline_Pressure", name: "Flowline Pressure" },
  { key: "Flowline_Temperature", name: "Flowline Temperature" },
  { key: "GCS_Advantage", name: "GCS Advantage" },
  { key: "GCS_Electrospeed", name: "GCS Electrospeed" },
  { key: "GCS_Electrostart", name: "GCS Electrostart" },
  { key: "H2S_Sensor", name: "H2S Sensor" },
  { key: "Novomet", name: "Novomet" },
  { key: "Oxford", name: "Oxford" },
  { key: "PHController", name: "PHController" },
  { key: "Phoenix", name: "Phoenix" },
  { key: "SLB_Instruct", name: "SLB Instruct" },
  { key: "Tank_Level", name: "Tank Level" },
  { key: "Uniconn", name: "Uniconn" },
  { key: "Uniconn_SWB", name: "Uniconn SWB" },
  { key: "View_Point", name: "View Point" },
  { key: "Well_Lift", name: "Well Lift" },
  { key: "Wellhead_Pressure", name: "Wellhead Pressure" },
  { key: "Zenith", name: "Zenith" },
];

// export const CHANNEL_PORTS = [
//     { key: "RS232-Port1", value: "RS232-Port1" },
//     { key: "RS232-Port2", value: "RS232-Port2" },
//     { key: "RS232-Port3", value: "RS232-Port3" },
//     { key: "RS485-Port1", value: "RS485-Port1" },
//     { key: "RS485-Port2", value: "RS485-Port2" }
// ];

export const CHANNEL_PORTS = [
  { key: "/dev/ttymxc3", value: "RS232-Port1" },
  { key: "/dev/ttyMAX2", value: "RS232-Port2" },
  { key: "/dev/ttymxc4", value: "RS232-Port3" },
  { key: "/dev/ttyMAX0", value: "RS485-Port1" },
  { key: "/dev/ttyMAX1", value: "RS485-Port2" },
  { key: "/dev/ttyUSB0", value: "USB-Port1" },
  { key: "/dev/ttyUSB1", value: "USB-Port2" },
  { key: "/dev/ttyUSB2", value: "USB-Port3" }
];

export const BOARD_RATES = [
  { key: 300, value: 300 },
  { key: 600, value: 600 },
  { key: 1200, value: 1200 },
  { key: 2400, value: 2400 },
  { key: 4800, value: 4800 },
  { key: 9600, value: 9600 },
  { key: 14400, value: 14400 },
  { key: 19200, value: 19200 },
  { key: 38400, value: 38400 },
  { key: 56000, value: 56000 },
  { key: 57600, value: 57600 },
  { key: 115200, value: 115200 },
  { key: 128000, value: 128000 },
  { key: 153600, value: 153600 },
  { key: 230400, value: 230400 },
  { key: 256000, value: 256000 },
  { key: 460800, value: 460800 },
  { key: 821600, value: 821600 },
];

export const DATA_BITS_RTU_SERIAL = [
  { key: 5, value: 5 },
  { key: 6, value: 6 },
  { key: 7, value: 7 },
  { key: 8, value: 8 },
];

export const DATA_BITS_ASCII_SERIAL = [
  { key: 7, value: 7 },
  { key: 8, value: 8 },
];

export const PARITY = [
  { key: 0, value: "None" },
  { key: 1, value: "Odd" },
  { key: 2, value: "Even" },
  { key: 3, value: "Mark" },
  { key: 4, value: "Space" },
];

export const STOP_BIT = [
  { key: 0, value: "None" },
  { key: 1, value: "1" },
  { key: 2, value: "2" },
  { key: 3, value: "1.5" },
];
export const trendsPredefinedDates = ["1 D","1 W" , "1 M", "1 Y"];

export const predefinedResolution = ["1 sec", "1 minute", "1 hour", "1 day"];

export const LOCKOUT_TAG = "LOCKOUT_TAG";

export const SETPOINT_MODAL_TITLE = {
  CAUTION: "Update Setpoint",
  NO_LOCKOUT_TAG: "No Lockout Tag Configured"
}

export const CANCEL_SYNC_TITLE = "Cancel Sync";
export const PUBLISH_RATE = [
  {rate : '5 seconds', secondsValue: 5},
  {rate : '30 seconds', secondsValue: 30},
  {rate : '1 minute', secondsValue: 60},
  {rate : '5 minutes', secondsValue: 300},
  {rate : '30 minutes', secondsValue: 1800},
  {rate : '1 hour', secondsValue: 3600}
];
export const STREAM_TYPES = [
  {key : 'RealtimeStream', value: 'Realtime stream'},
  {key : 'EventStream', value: 'Event stream'},
  {key : 'NoStream', value: 'No stream'},
]

export const MAX_ASSIGNED_DEVICES = 50;

export const OMIT_VALUES = ['isSystem','tagType','equipmentId','templateTagId','equipmentTemplateId', 'slaveAddress', 'isOverridden', 'lastModifiedOn','isEditable', 'equipmentName', 'nodeChannelId', 'slaveAddress', 'isOverridden'];

export const DEVICE_TYPES = [
  {type: 'Witsml'},
  {type: 'PLEdge'},
  {type: 'Fusion'},
  {type: 'Chemical'}
];

export const PERIOD_TYPES = [
  { 'period': 'Last 7 days' },
  { 'period': 'Last 30 days' },
  { 'period': 'Last 2 months' },
  { 'period': 'Last 6 months' },
  { 'period': 'Custom' }
];

export const OMIT_DATA_TYPES_ALARMS = [ "array", "ascii","ascii8", "datetime","string","boolean"];

export const INTEGER_REGEX = /^-?[0-9]+$/;
export const BOOL_REGEX = /^[01]$/;
export const DOUBLE_REGEX = /^[+-]?(\d*\.)?\d+$/;

export const DEFAULT_ORG_NAME = 'BakerHughes New Devices';

export const BIT_INDEX_REGISTERS = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15];

